import React from "react";
import "./bothStyle.css";

function Both() {
  return (
    <div>
      <h1>Battle of Halls</h1>
      <h3>Spoons link should go here</h3>
    </div>
  );
}
export default Both;